const firebaseConfig = {
    apiKey: "AIzaSyBr38oWoJESqQVz_bK_87xaAeeok6YJSGc",
    authDomain: "land-web-4f1ad.firebaseapp.com",
    projectId: "land-web-4f1ad",
    storageBucket: "land-web-4f1ad.appspot.com",
    messagingSenderId: "558111585509",
    appId: "1:558111585509:web:d4f959633b519cc7d8900c",
    measurementId: "G-EFDK0LKB23",
    databaseURL: "land-web-4f1ad-default-rtdb.asia-southeast1.firebasedatabase.app"
};

export default firebaseConfig;
